"use client";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Feedback from "react-bootstrap/Feedback";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import FormText from "react-bootstrap/FormText";

export default () => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true)
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit} action="/login/local" method="post">
      <FormGroup className="mb-3" controlId="email">
        <FormLabel>Email</FormLabel>
        <FormControl
          required
          type="email"
          placeholder="Email"
          name="email"
        />
        <Feedback type="invalid">You must enter an email.</Feedback>
      </FormGroup>
      <FormGroup className="mb-3" controlId="password">
        <FormLabel>Password</FormLabel>
        <FormControl
          required
          type="password"
          placeholder="Password"
          name="password"
        />
        <Feedback type="invalid">You must enter a password.</Feedback>
      </FormGroup>
      <Button type="submit" className="w-100">Login</Button>
    </Form>
  )
}